import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

function MarkdownLink({ href, children }: { href?: string | undefined; children?: React.ReactNode }) {
  if (href?.startsWith('/app/')) {
    return (
      <Link to={href} className="text-[hsl(var(--link))] hover:underline">
        {children}
      </Link>
    )
  }
  return (
    <a href={href} target="_blank" rel="noreferrer" className="text-[hsl(var(--link))] hover:underline">
      {children}
    </a>
  )
}

interface HelpMarkdownProps {
  children: string
  compact?: boolean
}

export function HelpMarkdown({ children, compact }: HelpMarkdownProps) {
  return (
    <article
      className={cn(
        'prose prose-neutral max-w-none prose-headings:font-semibold prose-p:text-sm prose-li:text-sm prose-strong:font-semibold prose-a:no-underline',
        compact
          ? 'prose-p:my-1 prose-p:text-xs prose-li:text-xs'
          : 'prose-h1:text-xl prose-h2:text-base prose-h3:text-sm'
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: MarkdownLink }}>
        {children}
      </ReactMarkdown>
    </article>
  )
}
